import { createContext, useContext, useState } from "react";

const NotificationContext = createContext();

export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error(
      "useNotifications must be used within a NotificationProvider"
    );
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const addNotification = (notification) => {
    const baseId =
      notification?.id !== undefined && notification?.id !== null
        ? String(notification.id)
        : String(Date.now());
    const normalizedNotification = {
      ...notification,
      id: `${baseId}-${Math.random().toString(36).slice(2, 8)}`,
    };

    setNotifications((currentNotifications) => {
      const newNotifications = [...currentNotifications, normalizedNotification];
      return newNotifications.slice(-4);
    });
  };

  const removeNotification = (id) => {
    setNotifications((currentNotifications) =>
      currentNotifications.filter((notification) => notification.id !== id)
    );
  };

  return (
    <NotificationContext.Provider
      value={{ notifications, addNotification, removeNotification }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
